@if (!isLoading) {
  <app-components-specialist-actioncomponents-page-optimization-shared-instructions
    [taskId]="taskId"
    [websiteUrlId]="websiteUrlId"
    [googleSearchUrl]="customer.Country.GoogleSearchUrl">
  </app-components-specialist-actioncomponents-page-optimization-shared-instructions>

  <app-components-specialist-actioncomponents-page-optimization-shared-notes
    [customer]="customer"
    [taskId]="taskId"
    [currentNoteType]="TaskNoteTypes.ContentFeedback"
    [workflowId]="workflowId">
  </app-components-specialist-actioncomponents-page-optimization-shared-notes>

  <app-components-specialist-actioncomponents-page-optimization-shared-audit
    [orderingTask]="orderingTask"
    [workflowId]="workflowId"
    [taskId]="taskId"
    [userId]="userId"
    [customerId]="customer.CustomerId"
    [websiteUrlId]="websiteUrlId"
    [createSnapshot]="true"
    (auditChanged)="onAuditChanged()">
  </app-components-specialist-actioncomponents-page-optimization-shared-audit>

  <app-components-specialist-actioncomponents-page-optimization-shared-content
    [orderingTask]="orderingTask"
    [workflowId]="workflowId"
    [taskId]="taskId"
    [userId]="userId"
    [customerId]="customer.CustomerId"
    [websiteUrlId]="websiteUrlId"
    [createSnapshot]="true"
    (contentChanged)="onContentChanged()">
  </app-components-specialist-actioncomponents-page-optimization-shared-content>

  <app-components-specialist-actioncomponents-page-optimization-shared-floating-panels
    [orderingTask]="orderingTask"
    [customer]="customer"
    [taskId]="taskId"
    [showInformation]="true"
    [showTaskFiles]="true"
    [showCustomerFiles]="true"
    [showCustomerCampaign]="true">
  </app-components-specialist-actioncomponents-page-optimization-shared-floating-panels>

  <app-components-specialist-actioncomponents-page-optimization-shared-note
    [userId]="userId"
    [taskId]="taskId"
    [label]="'Content Feedback'"
    [noteType]="TaskNoteTypes.ContentFeedback"
    [createFeedback]="true"
    (noteChanged)="onNoteChanged()">
  </app-components-specialist-actioncomponents-page-optimization-shared-note>
}